module.exports = __webpack_public_path__ + "img/soccerboard58.83defa63.jpg";